module.exports = __webpack_public_path__ + "media/images/ui__infoOk--dark-f6e7648a4e6df556a0a05b0323f8af3e.png";